(function() {

  const ingredientsSliderFunction = () => {

    let selectors = {
      sectionIngredient: '.ingredients-slider-section'
    };

    let ingredients = document.querySelectorAll(selectors.sectionIngredient);

    ingredients.forEach((ingredient, i) => {
      
      let ingredientsSlider = ingredient.querySelector('.ingredient-slider');

      var swiper = new Swiper(ingredientsSlider, {
        slidesPerView: 1,
        spaceBetween: 30,
        keyboard: {
          enabled: true,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          300: {
            centeredSlides: false,
            slidesPerView: 2.2,
            spaceBetween: 15
          },
          543: {
            centeredSlides: false,
            slidesPerView: 3,
            spaceBetween: 15
          },
          991: {
            centeredSlides: false,
            slidesPerView: 4,
            spaceBetween: 30
          }
        }
      });

    })
    
  }

  document.addEventListener("DOMContentLoaded", function () {
		ingredientsSliderFunction();
	});

	document.addEventListener("shopify:section:load", function () {
		ingredientsSliderFunction();
	});

})();